import { Component } from '@angular/core';

@Component({
  selector: 'fgb-fitness-tracker-page',
  templateUrl: './fitness-tracker-page.component.html',
  styleUrl: './fitness-tracker-page.component.scss',
})
export class FitnessTrackerPageComponent {}
